/**
 * Constantes da Competição
 * Configurações estáticas e valores padrão para o módulo de competições.
 */

export const COMPETITION_SLUG = "taca-outono";
export const COMPETITION_FEE = 39.00;
export const COMPETITION_NAME = "Taça Outono de Natação";
export const COMPETITION_START_DATE = "2026-04-01T00:00:00-03:00"; // Ajuste conforme a real
export const COMPETITION_END_DATE = "2026-06-30T23:59:59-03:00"; // Ajuste conforme a real

export const COMPETITION_MAX_LAPS = 80;
export const COMPETITION_POOL_LANE_SIZE = 25;
export const COMPETITION_INSCRIPTION_CLOSED = true;
export const COMPETITION_RESULTS_CLOSED = true;

export const MERCADO_PAGO_SDK_URL = "https://sdk.mercadopago.com/js/v2";
export const BRICK_CONTAINER_ID = "competition-payment-brick";

export const INITIAL_FORM_DATA = {
    firstName: '',
    lastName: '',
    birthDate: '',
    gender: '',
    email: '',
    phone: '',
    club: '',
    clubState: '',
    professor: '',
    zipCode: '',
    state: '',
    city: '',
    neighborhood: '',
    street: '',
    number: '',
    password: '',
    confirmPassword: '',
};

export const GENDER_OPTIONS = [
    { value: '', label: 'Selecione...' },
    { value: 'M', label: 'Masculino' },
    { value: 'F', label: 'Feminino' },
];

export const BRAZILIAN_STATES = [
    { value: '', label: 'Selecione...' },
    { value: 'AC', label: 'Acre' },
    { value: 'AL', label: 'Alagoas' },
    { value: 'AP', label: 'Amapá' },
    { value: 'AM', label: 'Amazonas' },
    { value: 'BA', label: 'Bahia' },
    { value: 'CE', label: 'Ceará' },
    { value: 'DF', label: 'Distrito Federal' },
    { value: 'ES', label: 'Espírito Santo' },
    { value: 'GO', label: 'Goiás' },
    { value: 'MA', label: 'Maranhão' },
    { value: 'MT', label: 'Mato Grosso' },
    { value: 'MS', label: 'Mato Grosso do Sul' },
    { value: 'MG', label: 'Minas Gerais' },
    { value: 'PA', label: 'Pará' },
    { value: 'PB', label: 'Paraíba' },
    { value: 'PR', label: 'Paraná' },
    { value: 'PE', label: 'Pernambuco' },
    { value: 'PI', label: 'Piauí' },
    { value: 'RJ', label: 'Rio de Janeiro' },
    { value: 'RN', label: 'Rio Grande do Norte' },
    { value: 'RS', label: 'Rio Grande do Sul' },
    { value: 'RO', label: 'Rondônia' },
    { value: 'RR', label: 'Roraima' },
    { value: 'SC', label: 'Santa Catarina' },
    { value: 'SP', label: 'São Paulo' },
    { value: 'SE', label: 'Sergipe' },
    { value: 'TO', label: 'Tocantins' },
];

export const SWIMMING_AGE_CATEGORIES = [
    { label: "Pré-Mirim", minAge: 0, maxAge: 8 },
    { label: "Mirim 1", minAge: 9, maxAge: 9 },
    { label: "Mirim 2", minAge: 10, maxAge: 10 },
    { label: "Petiz 1", minAge: 11, maxAge: 11 },
    { label: "Petiz 2", minAge: 12, maxAge: 12 },
    { label: "Infantil 1", minAge: 13, maxAge: 13 },
    { label: "Infantil 2", minAge: 14, maxAge: 14 },
    { label: "Juvenil 1", minAge: 15, maxAge: 15 },
    { label: "Juvenil 2", minAge: 16, maxAge: 16 },
    { label: "Júnior 1", minAge: 17, maxAge: 17 },
    { label: "Júnior 2", minAge: 18, maxAge: 19 },
    { label: "Pré-Master", minAge: 20, maxAge: 24 }, // Agrupa 20-24 amadores/sênior
    { label: "Master A", minAge: 25, maxAge: 29 },
    { label: "Master B", minAge: 30, maxAge: 34 },
    { label: "Master C", minAge: 35, maxAge: 39 },
    { label: "Master D", minAge: 40, maxAge: 44 },
    { label: "Master E", minAge: 45, maxAge: 49 },
    { label: "Master F", minAge: 50, maxAge: 54 },
    { label: "Master G", minAge: 55, maxAge: 59 },
    { label: "Master H", minAge: 60, maxAge: 64 },
    { label: "Master I", minAge: 65, maxAge: 69 },
    { label: "Master J", minAge: 70, maxAge: 74 },
    { label: "Master K", minAge: 75, maxAge: 79 },
    { label: "Master L", minAge: 80, maxAge: 84 },
    { label: "Master M", minAge: 85, maxAge: 89 },
    { label: "Master N", minAge: 90, maxAge: 94 },
    { label: "Master O", minAge: 95, maxAge: 99 },
    { label: "Master P", minAge: 100, maxAge: 150 }
];
